/**
 * layoutConfig state consists of a string describing a configuration for AppLayout.
 */

import * as actionTypes from "../actions/actionTypes";

const VALID_CONFIGS = [
  "default", // show all elements
  "noNav", // hide all navigation elements, showing only the content
];

export default function layoutConfig(state = "default", action) {
  if (action.type !== actionTypes.SET_LAYOUT_CONFIG) return state;

  if (VALID_CONFIGS.includes(action.layoutConfig)) {
    return action.layoutConfig;
  } else {
    console.warn(`Invalid layoutConfig: ${action.layoutConfig}`);
  }

  return state;
}
